export default __webpack_public_path__ + "static/media/pen.cd161336.svg";